import { FirestoreDatabase as Database } from "../../db/common";
import { LISTING_REVIEWS_COLLECTION, ListingReview, LISTINGS_COLLECTION } from "../../db/listings";
import { BaseFirestoreServiceWithTimestamp } from "../FirestoreService";

/**
 * Shared Listing Reviews Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class ListingReviewsService extends BaseFirestoreServiceWithTimestamp<ListingReview> {
    constructor(protected db: Database, protected listingId: string) {
        super(db);
    }
    protected getCollectionPath(): string {
        return `${LISTINGS_COLLECTION}/${this.listingId}/${LISTING_REVIEWS_COLLECTION}`;
    }

}